// Vendors
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useErrorBoundary } from 'react-error-boundary';
// Contexts
import { useLayoutContextConsumerHook } from 'components/layout/contexts/layout.context';
import { usePaymentContextConsumerHook } from 'containers/payment/contexts/payment.context';
// Event Handlers
import { PaymentLandingHandlers } from '../handlers/payment-landing.handlers';
import { PaymentLandingTrackingHandlers } from '../handlers/payment-landing.tracking.handlers';
// Hooks
import { useAppTrackingHook } from 'tracking/app-tracking.hook';
// Types
import { PaymentLandingHookType } from './types/payment-landing.hook.type';

const usePaymentLandingHook = (): PaymentLandingHookType => {
  const [fetching, setFetching] = useState(true);

  const { formatMessage } = useIntl();

  const { showBoundary: setError } = useErrorBoundary();

  const { setMainButtonConfiguration } = useLayoutContextConsumerHook(),
    {
      clientSecret,
      setCardCountry,
      setCardPublicKey,
      setClientSecret,
      setIdentificationId,
      setStripePromise,
      stripePromise,
      timeoutRef: paymentTimeoutRef,
    } = usePaymentContextConsumerHook();

  const { handleTrackPaymentView } = useAppTrackingHook(PaymentLandingTrackingHandlers);

  const { handleFetchInitiatePaymentData } = PaymentLandingHandlers({
    formatMessage,
    paymentTimeoutRef,
    setCardCountry,
    setCardPublicKey,
    setClientSecret,
    setError,
    setFetching,
    setIdentificationId,
    setMainButtonConfiguration,
    setStripePromise,
  });

  useEffect(() => {
    handleFetchInitiatePaymentData();
    handleTrackPaymentView();
  }, []);

  return {
    clientSecret,
    fetching,
    stripePromise,
  };
};

export { usePaymentLandingHook };
